import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  
  if (!token) {
    return <Navigate to={process.env.REACT_APP_ADMIN_PATH} replace />;
  }

  return children;
};

export default PrivateRoute;
